/**
 * Joins names for inline prose inside a ledger row. Capped at three so a
 * blocked row cannot wrap to four lines on a long member list.
 */
export function formatNameList(names: string[] | undefined): string | undefined {
  const clean = (names ?? []).filter((n) => n.trim() !== "");
  if (clean.length === 0) return undefined;
  if (clean.length === 1) return clean[0];
  if (clean.length === 2) return `${clean[0]} and ${clean[1]}`;
  if (clean.length === 3) return `${clean[0]}, ${clean[1]} and ${clean[2]}`;
  return `${clean[0]}, ${clean[1]} and ${clean.length - 2} others`;
}
